// extracted by mini-css-extract-plugin
export default {"quotation1":"Quotation1_quotation1__RVR2B"};